import selectLook from 'html/customize/select-look.html';
import App from 'app/app.js';
import 'app/directive/LtBrowseAndSelectLookDrawerCtrl.js';

function LtSelectLookDrawer2Directive() {
  return {
    restrict: 'E',
    scope: {
      onInit: '&',
      onSelectedLook: '&',
      onCancellation: '&',
      onGoFavoriteLooks: '&',
      lookForItem: '='
    },
    template: selectLook,
    controller: 'LtBrowseAndSelectLookDrawerCtrl',
    controllerAs: 'browseAndSelectLookDrawer'
  };
}

App.directive('ltSelectLookDrawer2', [LtSelectLookDrawer2Directive]);
